export const FETCH_EXPERT_PROFILE_REQUEST = "FETCH_EXPERT_PROFILE_REQUEST";
export const FETCH_EXPERT_PROFILE_SUCCESS = "FETCH_EXPERT_PROFILE_SUCCESS";
export const FETCH_EXPERT_PROFILE_FAIL = "FETCH_EXPERT_PROFILE_FAIL";

export const UPSERT_EXPERT_PROFILE_REQUEST = "UPSERT_EXPERT_PROFILE_REQUEST";
export const UPSERT_EXPERT_PROFILE_SUCCESS = "UPSERT_EXPERT_PROFILE_SUCCESS";
export const UPSERT_EXPERT_PROFILE_FAIL = "UPSERT_EXPERT_PROFILE_FAIL";

export const SUBMIT_EXPERT_PROFILE_FOR_REVIEW_REQUEST =
  "SUBMIT_EXPERT_PROFILE_FOR_REVIEW_REQUEST";
export const SUBMIT_EXPERT_PROFILE_FOR_REVIEW_SUCCESS =
  "SUBMIT_EXPERT_PROFILE_FOR_REVIEW_SUCCESS";
export const SUBMIT_EXPERT_PROFILE_FOR_REVIEW_FAIL =
  "SUBMIT_EXPERT_PROFILE_FOR_REVIEW_FAIL";

export const FETCH_EXPERT_PROFILE_BY_USER_ID_REQUEST =
  "FETCH_EXPERT_PROFILE_BY_USER_ID_REQUEST";
export const FETCH_EXPERT_PROFILE_BY_USER_ID_SUCCESS =
  "FETCH_EXPERT_PROFILE_BY_USER_ID_SUCCESS";
export const FETCH_EXPERT_PROFILE_BY_USER_ID_FAIL =
  "FETCH_EXPERT_PROFILE_BY_USER_ID_FAIL";

export const FETCH_EXPERT_LIST_REQUEST = "FETCH_EXPERT_LIST_REQUEST";
export const FETCH_EXPERT_LIST_SUCCESS = "FETCH_EXPERT_LIST_SUCCESS";
export const FETCH_EXPERT_LIST_FAIL = "FETCH_EXPERT_LIST_FAIL";

export const RESET_EXPERT_PROFILE_ERROR = "RESET_EXPERT_PROFILE_ERROR";
